import React from 'react';
import Heading from '../../../../generic-components/Heading';
import { ReactComponent as ZeroStateIcon } from '../../../../assets/icons/svg/large-icons/ic-large-categorization-reload.svg';

export const LatestTransactionsZeroState = () => (
  <div className='flex flex-col items-center'>
    <Heading title='Latest Transactions' className='w-full font-metricRMedium pb-[12px] mb-[60px] border-b-[1px] border-bw03 text-[16px] text-bw08' />
    <ZeroStateIcon className='mb-[30px]' />
    <Heading title='You haven’t completed any transactions yet' className='font-metricR text-[14px] leading-[18px] text-bw06 text-center' />
  </div>
);
